require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-dot-net-developer-india.json") })
        }
      }, "path---careers-dot-net-developer-india");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-dot-net-developer-india!./.cache/json/careers-dot-net-developer-india.json
// module id = 858
// module chunks = 231608221292675